document.addEventListener('submit', function (event) {
  var form = event.target.closest('.newsletter-village-banner-form');
  if (!form) return;

  event.preventDefault();

  var section = form.closest('[data-newsletter-village-banner]');
  if (!section) return;

  var fieldRow = section.querySelector('[data-form-row]');
  var termsEl = section.querySelector('[data-form-terms]');
  var messageEl = section.querySelector('[data-form-message]');
  var submitBtn = form.querySelector('button[type="submit"]');

  if (submitBtn) submitBtn.disabled = true;

  fetch(form.action, {
    method: 'POST',
    body: new FormData(form),
  })
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newMessage = messageEl ? doc.getElementById(messageEl.id) : null;

      if (submitBtn) submitBtn.disabled = false;

      if (!newMessage || !messageEl) {
        form.submit();
        return;
      }

      messageEl.innerHTML = newMessage.innerHTML;
      var state = newMessage.getAttribute('data-state');

      if (state) {
        messageEl.setAttribute('data-state', state);
        messageEl.hidden = false;
      } else {
        messageEl.hidden = true;
      }

      if (state === 'success') {
        if (fieldRow) fieldRow.hidden = true;
        if (termsEl) termsEl.hidden = true;
      }
    })
    .catch(function () {
      if (submitBtn) submitBtn.disabled = false;
      form.submit();
    });
});
